export const cardLocales = {
  invalidCvv: 'Invalid CVV Code',
  invalidCcNumber: 'Invalid Card number',
  invalidExpDate: 'Invalid Validation Date'
}
